import React from "react";
import moment from "moment";
import "moment-timezone";
import {DATE_RANGES_MAP} from "../../../models/options";
import {getSelectedTimezone} from "../../../utils/dateutils";

/**
 * Builds an Elastic Search queries from date range filter values
 *
 * @param {Object} dateRangeFilter Object with date range filter values
 * @returns {Object} Object with values needed for query
 */
export const getDateRangeQueryValues = (dateRangeFilter) => {
  const dateRange = {};

  switch (dateRangeFilter?.filter) {
    case DATE_RANGES_MAP.TODAY.value: {
      dateRange.from = moment.tz(moment().subtract(24, "h"), "UTC").format();
      break;
    }
    case DATE_RANGES_MAP.LAST7DAYS.value: {
      dateRange.from = moment.tz(moment().subtract(7, "d"), "UTC").format();
      break;
    }
    case DATE_RANGES_MAP.LAST30DAYS.value: {
      dateRange.from = moment.tz(moment().subtract(30, "d"), "UTC").format();
      break;
    }
    case DATE_RANGES_MAP.CUSTOM.value: {
      const customStart = dateRangeFilter.startDate
        ? moment(dateRangeFilter.startDate).format("YYYY-MM-DD")
        : null;
      const customEnd = dateRangeFilter.endDate
        ? moment(dateRangeFilter.endDate).format("YYYY-MM-DD")
        : null;
      if (customStart && customEnd) {
        const customStartDate = moment.tz(customStart, getSelectedTimezone());
        const customEndDate = moment.tz(customEnd, getSelectedTimezone());
        dateRange.from = moment
          .tz(customStartDate.startOf("day"), "UTC")
          .format();
        dateRange.to = moment.tz(customEndDate.endOf("day"), "UTC").format();
      }
      break;
    }
    case DATE_RANGES_MAP.LASTYEAR.value:
    default:
      dateRange.from = moment.tz(moment().subtract(1, "y"), "UTC").format();
      break;
  }

  return dateRange;
};

export const getSearchErrorMessage = (error, genericMessage) => {
  if (error && error.data) {
    const type = error.data.type;
    if (type === "ES query parsing error") {
      return (
        <div className="content">
          <div>{error.data.type}</div>
          <div>{`Hint: Escape special characters with backslash(\\)`}</div>
          Use{" "}
          <a
            href="https://lucene.apache.org/core/2_9_4/queryparsersyntax.html"
            target="_blank"
            rel="noopener noreferrer">
            lucene syntax
          </a>{" "}
        </div>
      );
    }
  }
  return genericMessage;
};
